import store from "../store/store";

function onVisibilityChange(e) {
  store.dispatch.sessionModel.setPageVisible(!document.hidden);
}

export function addPageVisibleListener() {
  window.addEventListener("visibilitychange", onVisibilityChange, false);
}
